import { css } from '@/styled-system/css';

export const container = css({
  display: 'none',
  md: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '2x',
  },
});

export const toggleGroup = css({
  display: 'flex',
  borderRadius: '8px',
  overflow: 'hidden',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
});

const toggleButtonBase = css.raw({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  minHeight: '32px',
  padding: '4px 10px',
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '1',
  cursor: 'pointer',
  borderWidth: 0,
  transition: 'background-color 0.15s, color 0.15s',
});

export const toggleButtonActive = css(toggleButtonBase, {
  bg: 'hpxTeal500',
  color: 'hpxWhite',
});

export const toggleButtonInactive = css(toggleButtonBase, {
  bg: 'hpxWhite',
  color: 'hpxBlue600',
  _hover: {
    bg: 'hpxGrey100',
  },
});

export const iconStyle = css({
  width: '14px',
  height: '14px',
});

export const mobileToggleButton = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  minHeight: '32px',
  borderRadius: '8px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  bg: 'hpxTeal500',
  color: 'hpxWhite',
  cursor: 'pointer',
  padding: 0,
});
